import styled from '@emotion/styled';

type HighlightBoxColor = 'green' | 'orange';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing[40]};
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[40]} ${theme.spacing[50]}`};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
`;

const AccentBlock = styled.div<{ color?: HighlightBoxColor }>`
  padding: 0 ${({ theme }) => theme.spacing[40]} 0
    ${({ theme }) => theme.spacing[50]};
  border-left: 4px solid
    ${({ theme, color }) =>
      color === 'orange'
        ? theme.colors.brand.orange60
        : theme.colors.brand.green60};
`;

const Content = styled.div`
  color: ${({ theme }) => theme.colors.neutral.grey160};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: ${({ theme }) => theme.fontSize.sm.size};
  font-weight: 600;
  line-height: ${({ theme }) => theme.fontSize.sm.lineHeight};
  overflow-wrap: break-word;

  p {
    margin: 0;
  }
`;

export { Wrapper, AccentBlock, Content };
export type { HighlightBoxColor };
